import { InAppBrowser, ToolbarPosition, iOSViewStyle, iOSAnimation } from '@capacitor/inappbrowser';
import { isNativePlatform } from './platform';

interface PaymentCallbacks {
  onSuccess: () => void;
  onFailure: (error?: string) => void;
  onClose: () => void;
}

let currentCallbacks: PaymentCallbacks | null = null;

/**
 * Open a URL in the in-app WebView (for payments)
 * The PaymentReturn page handles status detection and closing the WebView
 */
export const openPaymentWebView = async (
  url: string,
  callbacks: PaymentCallbacks
): Promise<void> => {
  if (!isNativePlatform()) {
    // On web, use regular redirect
    window.location.href = url;
    return;
  }

  currentCallbacks = callbacks;

  // Add listener for browser closed (user manually closes)
  await InAppBrowser.addListener('browserClosed', () => {
    console.log('Browser was closed by user');
    InAppBrowser.removeAllListeners();
    if (currentCallbacks) {
      currentCallbacks.onClose();
      currentCallbacks = null;
    }
  });

  // Open the payment URL in WebView
  await InAppBrowser.openInWebView({
    url,
    options: {
      showURL: false,
      showToolbar: true,
      clearCache: false,
      clearSessionCache: false,
      mediaPlaybackRequiresUserAction: false,
      closeButtonText: 'Done',
      toolbarPosition: ToolbarPosition.TOP,
      showNavigationButtons: false,
      leftToRight: false,
      android: {
        allowZoom: false,
        hardwareBack: true,
        pauseMedia: true,
      },
      iOS: {
        allowOverScroll: false,
        enableViewportScale: false,
        allowInLineMediaPlayback: true,
        surpressIncrementalRendering: false,
        viewStyle: iOSViewStyle.FULL_SCREEN,
        animationEffect: iOSAnimation.COVER_VERTICAL,
        allowsBackForwardNavigationGestures: false,
      },
    },
  });
};

/**
 * Close the in-app WebView
 */
export const closePaymentWebView = async (): Promise<void> => {
  if (isNativePlatform()) {
    try {
      await InAppBrowser.close();
      InAppBrowser.removeAllListeners();
    } catch (error) {
      console.log('Error closing WebView:', error);
    }
  }
};
